import React, { Component, } from 'react'

import PropTypes from 'prop-types'

import {CCUIUtils, Constants, strings, CCUtils, CCButton, colors } from "./../../cc-imports";
// import './notification-item.css'
import './../../styles/css/components/CCNotificationItem/cc-notification-item.css'


class CCNotificationItem extends Component {

    static propTypes = {
        onClaim : PropTypes.func,
        userId : PropTypes.string
    }

    static defaultProps = {
        first: false,
        onClaim:()=>{},
        userId:undefined
    }

    constructor(props) {
        super(props)
        this.state = {

        }
    }

    _getTitle(notification){
        switch (notification.type){
            case 'MATCH_SUMMARY':
                let formatDate = (new Date(notification.match.date)).toLocaleDateString("en-US", {
                    year: '2-digit',
                    month: 'short',
                    day: 'numeric'
                });
                return notification.match.shortName + ' - ' + formatDate;
                break;
            case 'INVITATION_ACCEPTED':
                var isInvitee = this.props.userId == notification.invitee.id;
                if(isInvitee){
                    return strings('received_invitation_bonus');
                }
                else {
                    return strings('invitation_accepted');
                }
                break;
            case 'REWARD_NOTIFICATION':
                return CCUIUtils.getLocaleStr(notification.title);
                break;
        }
    }

    _getMessage(ntfn){
        switch (ntfn.type){
            case 'MATCH_SUMMARY':
                //console.log(ntfn,'thanu')

                return strings('won_lost_refunded_coins', {earnedCoins : ntfn.earnedCoins, lostCoins: ntfn.lostCoins, refundedCoins: ntfn.refundedCoins});
                break;
            case 'INVITATION_ACCEPTED':
                var isInvitee = this.props.userId == ntfn.invitee.id;
                if(isInvitee){
                    return strings('accepted_invitation_from', {invitedBy: ntfn.invitedBy.displayName, coins: ntfn.coins})
                    break;
                }
                else {
                    return strings('accepted_invitation_from_friend', {displayName: ntfn.invitee.displayName, coins: ntfn.coins});
                }
                break;
            case 'REWARD_NOTIFICATION':
                return CCUIUtils.getLocaleStr(ntfn.message);
        }
    }

    _getButtonTitle(ntfn){
        switch (ntfn.reward.status){
            case Constants.rewardStatus.CREATED:
                return strings('claim');
                break;
            case Constants.rewardStatus.CLAIMED:
            case Constants.rewardStatus.PROCESSED:
                return strings('view_button');
            default:
                return strings('claim');
        }
    }


    render() {
        const {notification} = this.props;
       // console.log(notification,'aaa')


        let time = CCUtils.formatTime(notification.createdDate);
        return (
            <div className="item flex-container" >
                <div className=" sub-item flex-container">
                        <div className="flex-container first-row">
                            <h1 className="title">{this._getTitle(notification)}</h1>
                            <h3 className="f-color">{time}</h3>
                        </div>
                        <div className="flex-container second-row">
                            <h3 className="msg">{this._getMessage(notification)}</h3>
                            {
                                notification.type=='REWARD_NOTIFICATION' &&
                                    <div>
                                        <CCButton type={'dark'} className={'ntfn-rwd-btn'} titleClassName={'btnTxt'}  title={this._getButtonTitle(notification)} onPress={this.props.onClaim} loading={this.state.fbLoading}/>
                                    </div>
                            }
                        </div>

                </div>
            </div>
        )
    }
}

export default CCNotificationItem;


// WEBPACK FOOTER //
// ./src/app/components/CCNotificationItem/CCNotificationItem.js